import { Component, OnInit, Input, NgZone, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { AdminTiketService } from '../../services/admin-tiket.service';
import { PostService } from '../../services/post.service';
import { IPage } from '../../model/page';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import {PagerService} from '../../services/pager.service';
//import {IMyDpOptions} from 'mydatepicker';
import { Observable, of, pipe, throwError } from 'rxjs';
import { mergeMap, map, switchMap, debounceTime, catchError } from 'rxjs/operators';
import { ModalComponent } from '../../shared/modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as jquery from 'jquery';
declare var $: any;

@Component({
    selector: 'app-post-list',
    templateUrl: './post-list.component.html',
    styleUrls: ['./post-list.component.scss'],
    standalone: false
})

export class PostListComponent implements OnInit {
  @Input() parent_id: any;
  @Input() parent_name: any;
  
  posts: any;
  isFilterTrue = true;
  // userValue: IUserValue;
  paging: IPage;
  per_page = 10;
  selected_status: number;
  filter: any = { 'name': '', 'order': 'asc'};
  curr_user_id: any;
  total: number = 0;
  public row_header: any = [];
  public header_index: any;
  public assignee_array: any = [];
  private allItems: any[];
  showloader: boolean;
  pager: any = {};
  pagedItems: any[];
  crumbList: any[];

  constructor(
    private adminSer: AdminTiketService,
    private pagerS: PagerService,
    private postSer: PostService,
    private modalService: NgbModal,
    private ngZone: NgZone) {
      this.showloader = true;
  }

  ngOnInit() {
    this.crumbList = [
      { title: 'Home', url: '/dashboard' },
      { title: 'Admin Menu', url: '/admins/admin-menu' }
    ];
    const userData = localStorage.getItem('UserData');
    this.curr_user_id = JSON.parse(userData);
    this.selected_status = null;

    this.row_header  = [
      {text: 'Order', value: 'Order', 'sort': 'desc'},
      {text: 'Title', value: 'Name', 'sort': null},
      {text: 'Body', value: 'Body', 'sort': 'none' }
    ];
    this.header_index = 0;

    this.tableSort(0);
  }

  findLocalPost( id: number ) {
     for ( var idx = 0; idx < this.posts.length; idx++ ) {
        const obj = this.posts[idx];
        if (obj.ID === id) {
          return obj;
        }
     }
     return null;
  }

  deletePost(id: number) {
    const post = this.findLocalPost( id );
    if (post === null) {
      alert('Unable to find Post');
      return;
    }
    const modalRef = this.modalService.open( ModalComponent );
    modalRef.componentInstance.confirmationStr = '<p><strong>Are you sure you want to delete ' +
    '<span class="text-primary">"' + post.Name + '"</span> record?</strong></p>' +
    '<p>All information associated to this Post record will be permanently deleted.' +
    '<span class="text-danger"> This operation can not be undone.</span>' +
    '</p>';
    modalRef.componentInstance.title = 'Post Record';
    modalRef.result.then((res: any) => {
      this.postSer.deletePost(id).subscribe((data: any) => {
        this.setPage(1);
      });
    })
    .catch( (res: any) => {
    });

  }

  filterByPost(event) {
    this.showloader = true;
    const id = event.target.value;
    this.filter.companyname = id;
    this.setPage(1);
  }

  setPage(page: number = 1) {
        const that = this;

        this.showloader = true;
        this.postSer
          .getAllPosts( this.parent_id, page, this.per_page, this.row_header[this.header_index], this.filter)
          .subscribe( {
              next(data: any) {
                that.showloader = false;
                that.posts = data.data; // return all data
                that.paging = data.page; // return all the paginationinfo
                that.total = that.paging.total;
                that.pager = that.pagerS.getPager(that.paging.total, page, that.per_page);
          },
          error(msg) {
            that.ngZone.run( () => {
              that.showloader = false;
            });
          }
        });
  }

  tableSort(index) {
    if (this.row_header[index].sort === 'none') {
       return;
    }

    this.showloader = true;
    if (this.header_index === index) {
      (this.row_header[index].sort === 'asc') ? this.row_header[index].sort = 'desc' : this.row_header[index].sort = 'asc';
    } else {
      this.row_header[index].sort = 'asc';
      this.row_header[this.header_index].sort = null;
      this.header_index = index;
    }
    this.setPage(1);
  }

  collapseMe() {
    $('.collapse.show').removeClass('show');
    this.setPage(1);
  }

}


